export function flatten<T>(array: T[][]): T[] {
  return array.reduce((flatten, arr) => {
    arr.forEach(elem => {
      flatten.push(elem);
    });
    return flatten;
  }, []);
}
